import * as React from 'react'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { GroupChannel } from 'sendbird'

import { familyProgramsPath, messagesPath } from 'main/routes'
import { SendbirdContext } from 'main/util/sendbird'
import { LOCIZE_NAMESPACE } from '../../../../common'
import { MessageCountIcon } from '../Icons'

import { StyledLink } from './styles'

function ParentLinks({ history }: RouteComponentProps) {
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const { unreadMessageCount, fetchLatestGroupChannelWithUnreadMessages } =
    useContext(SendbirdContext)

  const [unreadChannelUrl, setUnreadChannelUrl] = useState<string>('')

  fetchLatestGroupChannelWithUnreadMessages!().then((channel?: GroupChannel) => {
    if (!channel) return

    const url = channel.url.replace('sendbird_group_channel_', '')
    setUnreadChannelUrl(url)
  })

  return (
    <React.Fragment>
      <StyledLink to={familyProgramsPath()}>{t('COMPONENTS-HEADER-PARENT-LINKS-TEXT')}</StyledLink>
      <MessageCountIcon
        count={unreadMessageCount}
        onClick={() => history.push(`${messagesPath()}/${unreadChannelUrl}`)}
      />
    </React.Fragment>
  )
}

export default withRouter(React.memo(ParentLinks))
